import {
  READ_MICRO_LOAN_NOTIFICATION_ERROR,
  READ_MICRO_LOAN_NOTIFICATION_START,
  READ_MICRO_LOAN_NOTIFICATION_SUCCESS,
} from 'constants/action-types/loanRequests/microLoanNotifications';

export default (state, { type, payload }) => {
  switch (type) {
    case READ_MICRO_LOAN_NOTIFICATION_START:
      return {
        ...state,
        readMicroLoanNotification: {
          ...state.readMicroLoanNotification,
          loading: true,
          error: null,
        },
      };
    case READ_MICRO_LOAN_NOTIFICATION_ERROR:
      return {
        ...state,
        readMicroLoanNotification: {
          ...state.readMicroLoanNotification,
          error: payload,
          loading: false,
        },
      };
    case READ_MICRO_LOAN_NOTIFICATION_SUCCESS:
      return {
        ...state,
        readMicroLoanNotification: {
          ...state.readMicroLoanNotification,
          data: payload.data,
          error: null,
          loading: false,
        },
      };
    default:
      return null;
  }
};
